import React, { useState, useEffect } from "react";
import { Table, Col, Container, Row, Form } from "react-bootstrap";
import { AiOutlineFileSearch } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { AXIOS, api_key } from "../../../config";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import "./tab_style.css";
import { DatePicker, Space } from "antd";

const { RangePicker } = DatePicker;

const Trade_history = () => {
  const [activeSpan, setActiveSpan] = useState("1 week");
  const [rowsToShow, setRowsToShow] = useState(10);
  const [selectedOption, setSelectedOption] = useState("1");
  const [orderHistory, setOrderHistory] = useState([
    {
      _id: "",
      createdAt: "",
      pair_name: "",
      type: "",
      target_price: "",
      amount: "",
      tokenAmount: "",
      status: "",
      method: "",
    },
  ]);
  const [arr, setArr] = useState([
    {
      _id: "",
      createdAt: "",
      pair_name: "",
      type: "",
      target_price: "",
      amount: "",
      tokenAmount: "",
      status: "",
      method: "",
    },
  ]);
  const [actualData, setActualData] = useState([
    {
      _id: "",
      createdAt: "",
      pair_name: "",
      type: "",
      target_price: "",
      amount: "",
      tokenAmount: "",
      status: "",
      method: "",
    },
  ]);
  const { isLogin } = useSelector((state: any) => state.auth);
  const { isCreatedOrder, orderType } = useSelector((state: any) => state.spot);
  let userid = sessionStorage.getItem("userid");
  useEffect(() => {
    (async function() {
      try {
        let orderHistoryResponse = await AXIOS.post("getAllOrders", {
          api_key: api_key,
          // user_id: userid
        });
        console.log("orderHistoryResponse", orderHistoryResponse);
        if (orderHistoryResponse.data.data.length > 0) {
          // setOrderHistory(orderHistoryResponse.data.data)
          setActualData(orderHistoryResponse.data.data);
        }
      } catch (error) {
        // toast.error(error.message)
      }
    })();
  }, [isCreatedOrder, orderType, isLogin]);

  const filterData = async (val) => {
    // let val = event.target.value
    setSelectedOption(val);
    if (val == "1") {
      setArr(orderHistory);
    } else {
      let filteredItems = orderHistory.filter((item) => {
        return item.status == val;
      });
      filteredItems =
        filteredItems.length > 0
          ? filteredItems
          : [
              {
                _id: "",
                createdAt: "",
                pair_name: "",
                type: "",
                target_price: "",
                amount: "",
                tokenAmount: "",
                status: "",
                method: "",
              },
            ];
      setArr(filteredItems);
    }
  };
  async function filterDays(days) {
    const now = new Date();

    const DaysAgo = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);

    let filteredItems = actualData.filter((product) => {
      const hitDate = new Date(product.createdAt);

      return hitDate >= DaysAgo && hitDate <= now;
    });
    filteredItems =
      filteredItems.length > 0
        ? filteredItems
        : [
            {
              _id: "",
              createdAt: "",
              pair_name: "",
              type: "",
              target_price: "",
              amount: "",
              tokenAmount: "",
              status: "",
              method: "",
            },
          ];
    setOrderHistory(filteredItems);

    // filterData(selectedOption)

    // setArr(filteredItems)
  }
  useEffect(() => {
    if (actualData[0]._id.length > 0) {
      filterDays(7);
    }
  }, [actualData]);
  useEffect(() => {
    if (actualData[0]._id.length > 0) {
      filterData(selectedOption);
    }
  }, [orderHistory]);

  return (
    <>
      <div className="trade_data">
        {/* <div className="upper_data mx-lg-3">
          <div className="row">
            <div className="col-6 col-sm-4 col-lg-6 col-xl-4 d-flex align-items-center gap-1">
              <span className="trd_hstry_span">1 Day</span>
              <span
                className="btn btn-secondary p-1"
                style={{ fontSize: ".993em" }}
              >
                1 Week
              </span>
              <span className="trd_hstry_span">1 Month</span>
              <span className="trd_hstry_span">3 Months</span>
            </div>
            <div className="col-6 d-flex align-items-center">
              <Space direction="vertical" size={12}>
                <RangePicker />
              </Space>
            </div>
            <div className="col-3 col-sm-2 d-flex gap-2">
              <span
                className="btn btn-secondary m-0 p-1"
                style={{ fontSize: ".993em" }}
              >
                Inquire
              </span>
              <span
                className="btn btn-secondary m-0 p-1"
                style={{ fontSize: ".993em" }}
              >
                Reset
              </span>
            </div>
          </div>
        </div> */}

        {/* <Table responsive className='text-start' style={{ color: 'var(--text-clr)', fontSize: '.693em', marginInline: '3rem' }}>
                    <tr>
                        <th>Dates</th>
                        <th>Pair</th>
                        <th>DirectionPrice</th>
                        <th>Amount</th>
                        <th>Fee</th>
                        <th>Amount</th>
                    </tr>
                </Table> */}

        <div className="upper_data mx-lg-3 mb-2">
          <div className="row">
            <div
              className="col-12 col-sm-4 col-lg-6 col-xl-4 d-flex align-items-center gap-1"
              style={{ cursor: "pointer" }}
            >
              <span
                className={activeSpan === "1 day" ? " odr_hstry_span" : ""}
                onClick={() => {
                  setActiveSpan("1 day");
                  filterDays(1);
                }}
              >
                1 Day
              </span>
              <span
                className={activeSpan === "1 week" ? " odr_hstry_span" : ""}
                onClick={() => {
                  setActiveSpan("1 week");
                  filterDays(7);
                }}
              >
                1 Week
              </span>
              <span
                className={activeSpan === "1 month" ? " odr_hstry_span" : ""}
                onClick={() => {
                  setActiveSpan("1 month");
                  filterDays(30);
                }}
              >
                1 Month
              </span>
              <span
                className={activeSpan === "3 month" ? " odr_hstry_span" : ""}
                onClick={() => {
                  setActiveSpan("3 month");
                  filterDays(3 * 30);
                }}
              >
                3 Months
              </span>
            </div>
            <div className="col-6 mt-2 mt-sm-0 d-flex align-items-center">
              <Space direction="vertical" size={12}>
                <RangePicker />
              </Space>
            </div>

            <div className="col-6 mt-2 mt-sm-0 col-sm-2 d-flex gap-2">
              <span
                className="btn btn-secondary m-0 p-1"
                style={{ fontSize: ".993em" }}
              >
                Inquire
              </span>
              <span
                className="btn btn-secondary m-0 p-1"
                style={{ fontSize: ".993em" }}
              >
                Reset
              </span>
            </div>
          </div>
        </div>

        <div className="spot_tabs_histTable">
          <Table responsive size="lg"
            className="text-start"
            style={{
              color: "var(--text-clr)",
              fontSize: ".693em",
              border: "transparent",
            }}
          >
            <thead>
              <tr>
                <th>Dates</th>
                <th>Pair</th>
                <th>Type</th>
                <th>Direction</th>
                <th>Price</th>
                <th>Amount</th>
                <th>
                  <Form.Select
                    aria-label="Default select example"
                    size="sm"
                    className="orderHis_select"
                    onChange={(e) => {
                      filterData(e.target.value);
                    }}
                    value={selectedOption}
                  >
                    <option value="1">All</option>
                    <option value="0">Completed</option>
                    <option value="2">Cancelled</option>
                  </Form.Select>
                </th>
              </tr>
            </thead>
            <tbody>
              {arr[0]._id.length > 0 &&
                arr.slice(0, rowsToShow).map((item) => (
                  <tr key={item._id}>
                    <td>
                      {new Date(item.createdAt).toLocaleString("en-US", {
                        hour12: false,
                      })}
                    </td>
                    <td>{item.pair_name}</td>
                    <td>{item.type}</td>
                    <td>{item.method}</td>
                    <td>{item.target_price}</td>
                    <td>{item.tokenAmount}</td>
                    <td>
                      {Number(item.amount) > 0 && Number(item.status) == 0
                        ? "Cancelled"
                        : Number(item.amount) == 0 && Number(item.status) == 0
                        ? "Completed"
                        : "Open order"}
                    </td>
                  </tr>
                ))}
              {arr[0]._id.length < 1 && (
                <div
                  className="d-flex flex-column align-items-center justify-content-center mt-5"
                  style={{ color: "var(--text-clr)" }}
                >
                  <div className="display-6">
                    <i>
                      {" "}
                      <AiOutlineFileSearch />{" "}
                    </i>
                  </div>
                  <div>
                    <span>No records found</span>
                  </div>
                </div>
              )}
            </tbody>
          </Table>
          {arr.length > rowsToShow && (
            <button
              className="ms-auto btn btn-outline-warning"
              onClick={() => setRowsToShow(rowsToShow + 10)}
            >
              View More
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Trade_history;
